<template>
  <div class="source-api-box">
     <div class="source-api-content">
         <div class="source-api-item-add" @click="mode = 'create',dialogVisible = true">
             <div class="source-api-item-add-image">
                 <i class="el-icon-circle-plus"></i>
             </div>
             <div class="source-api-item-add-name">
                 添加API
             </div>
         </div>


         <div v-for="(item,index) in clueApis" :key="item.id"
         class="source-api-item"
         @click="showChooseedApi(item)">
             <div class="source-api-item-image">
             </div>
             <div class="source-api-item-name">
                 {{item.name}}
             </div>
             <div class="source-api-item-desc">
                  {{item.description}}
             </div>
         </div>
     </div>
     <!-- 抽屉 -->
     <el-drawer
        :title="currentClueApi.name"
        :visible.sync="apiViewDrawer"
        size="50%"
        direction="rtl">
        <div class="api-box">
            <div class="base-info">
                <div class="base-info">请求说明</div>
                <div class="base-info-item">
                    <div class="label">接口地址：</div>
                    <div class="content">
                        <span id="requestUrl">{{currentClueApi.url}}</span>
                        <i class="el-icon-copy-document" style="margin-left:10px;color:#409eff" 
                            v-clipboard:copy="currentClueApi.url"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                        </i>
                    </div>
                </div>
                <div class="base-info-item">
                    <div class="label">请求方式：</div>
                    <div class="content">POST</div>
                </div>
               <div class="base-info-item">
                    <div class="label">Content-Type：</div>
                    <div class="content">application/json</div>
                </div>
                <div class="base-info-item">
                    <div class="label">secret：</div>
                      <div class="content" style="width:16em" v-if="!displaySecret">******************</div>
                      <div v-else style="width:16em" class="content">{{currentClueApi.secret}}</div>
                      
                      <div @click="displaySecret=!displaySecret">
                        <svg v-if="!displaySecret" class="icon" width="16px" height="16.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fill="#333333" d="M512 437.3c-41.2 0-74.7 33.4-74.7 74.7 0 41.2 33.4 74.7 74.7 74.7 41.2 0 74.7-33.5 74.7-74.7s-33.5-74.7-74.7-74.7M512 213.3C264.6 213.3 64 512 64 512s200.6 298.7 448 298.7S960 512 960 512 759.4 213.3 512 213.3m0 485.4c-103.1 0-186.7-83.6-186.7-186.7S408.9 325.3 512 325.3 698.7 408.9 698.7 512 615.1 698.7 512 698.7" /></svg>
                        <svg v-else class="icon" width="16px" height="16.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fill="#333333" d="M186.88 134.4a20.48 20.48 0 0 0-29.866667 0l-22.613333 22.613333a20.48 20.48 0 0 0 0 29.866667L245.333333 298.666667a412.16 412.16 0 0 0-157.44 199.68A42.666667 42.666667 0 0 0 85.333333 512a34.56 34.56 0 0 0 2.56 13.226667A454.4 454.4 0 0 0 512 810.666667a469.333333 469.333333 0 0 0 199.253333-46.506667l125.866667 125.44a20.48 20.48 0 0 0 29.866667 0l22.613333-22.613333a20.48 20.48 0 0 0 0-29.866667zM512 640a128 128 0 0 1-128-128 123.306667 123.306667 0 0 1 15.786667-59.733333l170.666666 170.666666A123.306667 123.306667 0 0 1 512 640z m426.666667-140.8A455.253333 455.253333 0 0 0 389.12 230.826667L836.693333 678.4a401.493333 401.493333 0 0 0 99.413334-152.32A34.56 34.56 0 0 0 938.666667 512a39.68 39.68 0 0 0 0-12.8z" /></svg>
                      </div>
                           <i class="el-icon-copy-document" style="margin-left:10px;color:#409eff" 
                            v-clipboard:copy="currentClueApi.secret"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                        </i>
                </div>
                <div class="base-info-item">
                    <div class="label">mainId：</div>
                    <div class="content">{{currentClueApi.mainId}}</div>
                    <i class="el-icon-copy-document" style="margin-left:10px;color:#409eff" 
                            v-clipboard:copy="currentClueApi.mainId"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                    </i>
                </div>

               <div class="base-info-item">
                    <div class="label">备注说明：</div>
                    <div class="content">请求参数中token生成方式为 <span>AES(id+','+secret+','+mainId+','+timestamp,secret)</span></div>
                </div>
            </div>
            <div class="parameters">
                <div class="parameters-title">请求参数说明</div>
                <el-table
                    :data="tableData"
                    stripe
                    border
                    style="width: 90%">
                    <el-table-column
                    prop="name"
                    label="名称"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="required"
                    label="必填"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="type"
                    label="类型">
                    </el-table-column>
                    <el-table-column
                    prop="explain"
                    label="说明">
                    </el-table-column>
                </el-table>
            </div>
            <div class="parameters">
                <div class="parameters-title">返回参数说明</div>
                <pre class="pre-json">
                    {"code":"0","data":{"id":"609cf36b0ef08f3343957341"}}
                </pre>

                <el-table
                    :data="[{name: 'code', type: 'string',explain:'0表示请求成功,其他code参考错误码说明'},
                            {name: 'data.id', type: 'string',explain:'请求成功之后返回创建成功的线索ID'},]"
                    stripe
                    border
                    style="width: 90%">
                    <el-table-column
                    prop="name"
                    label="名称"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="type"
                    label="类型">
                    </el-table-column>
                    <el-table-column
                    prop="explain"
                    label="说明">
                    </el-table-column>
                </el-table>
            </div>

            <div class="parameters">
                <div class="parameters-title">错误码对照表</div>


                <el-table
                    :data="errorCodes"
                    stripe
                    border
                    style="width: 90%">
                    <el-table-column
                    prop="code"
                    label="code"
                    width="180">
                    </el-table-column>
                  
                    <el-table-column
                    prop="explain"
                    label="说明">
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top: 4px;">
                <el-button type="danger" @click="confirmDelete">删 除</el-button>
            </div>
           
        </div>
    </el-drawer>
    <el-dialog
        title="添加API"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="30%">
        <el-input v-model="apiName" placeholder="请输入API接入名称，如：官网注册"></el-input>
        <el-input v-model="apiDesc" placeholder="请输入API接入描述" type="textarea" style="padding-top: 24px;"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="createClueApi">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {CLUE_API_PARAMS,RESPONSE_CODE_DESC} from './constant';
export default {
    data(){
        return{
            apiViewDrawer: false,
            curentOpenUrl: 'http://new-test.guoranbot.com:31090/v2/api-docs',
            dialogVisible: false,
            apiName: '',
            apiDesc:'',
            tableData: [],
            currentClueApi:{},
            clueApis:[],
            displaySecret:false,
            errorCodes:[],
            mode: 'create',// create|update
        }
    },
    mounted(){
        this.loadClueApis();
        this.tableData = CLUE_API_PARAMS;
        this.errorCodes = RESPONSE_CODE_DESC;
    },
    methods:{
        confirmDelete(){
             this.$confirm('删除后将无法使用该接口推送线索, 是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.deleteApi(this.currentClueApi.id,(resp)=>this.loadClueApis(),this.apiViewDrawer = false);
        }).catch(() => {
                  
        });
        },
        deleteApi(apiId,callback){
            this.$http.delete('/scrm-api/custom-clue-api/'+apiId)
            .then((response)=>{
                console.debug('delete api resp:',response);
                if(callback){
                    callback(response);
                }
            });
        },
        showChooseedApi(api){
            this.mode = 'update';
            this.currentClueApi=api;
            this.currentClueApi.url = process.env.VUE_APP_SCRM_HOST+'/scrm-api/v1/custom-clue/'+this.currentClueApi.id;
            this.apiViewDrawer = true;
            this.displaySecret=false;
        },
        loadClueApis(){
            this.clueApis = [];
            this.$http.get('/scrm-api/custom-clue-api/list').then(res=>{
                this.clueApis = res.data;
            })
        },
        updateClueApi(){
            this.$http.post('/scrm-api/custom-clue-api/'+this.currentClueApi.id,{
                    name: this.currentClueApi.name,
                    description: this.currentClueApi.description
                }).then(res=>{
                    console.debug('update clue api res.data',res.data);
                    this.loadClueApis();
                })
        },
        createClueApi(){
            this.dialogVisible = false;

            this.$http.post('/scrm-api/custom-clue-api',{
                name: this.apiName,
                description: this.apiDesc
            }).then(res=>{
                console.debug('create clue api res.data',res.data);
                this.loadClueApis();
            })
        },
        onCopy() {
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        onError() {
            this.$message.error('复制失败');
        }
    }
}
</script>

<style lang="less">
@import url('../../assets/less/leadsSource/api.less');
.pre-json{
    background: #f7f7f7;
}
</style>